import { StanBadge } from '@/components';
import type { StanColumnDef } from '@/components/core-components/StanTable/StanTable.types';
import type { Recipient } from '../types';
import { getRecipientStatusText, getRecipientStatusVariant } from '../logic';

/**
 * Table column definitions for recipients table
 */
export const getRecipientColumns = (): StanColumnDef<Recipient>[] => [
    {
        id: 'name',
        header: 'Name',
        accessorKey: 'name',
        cell: info => {
            const value = info.getValue();
            return <span className='text-dark text-label-sm-regular'>{value as string}</span>;
        },
    },
    {
        id: 'email',
        header: 'Email',
        accessorKey: 'email',
        cell: info => {
            const value = info.getValue();
            return <span className='text-gray text-label-sm-regular'>{value as string}</span>;
        },
    },
    {
        id: 'status',
        header: 'Status',
        accessorKey: 'status',
        align: 'right',
        cell: info => {
            const status = info.getValue() as Recipient['status'];
            const variant = getRecipientStatusVariant(status);
            const text = getRecipientStatusText(status);

            return (
                <div className='flex justify-end'>
                    <StanBadge variant={variant} size='sm'>
                        {text}
                    </StanBadge>
                </div>
            );
        },
    },
];
